module.exports = __webpack_public_path__ + "static/media/211-Sturz-Ansprechen-Teil1_ID_7.69376e92.mp3";